import { render } from "./lawyerRequestedDetails.vue?vue&type=template&id=6a127b64"
import script from "./lawyerRequestedDetails.vue?vue&type=script&lang=js"
export * from "./lawyerRequestedDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__